<div id="bottomDialog" class="bottom-dialog-container text">
  <ng-container [ngSwitch]="['wettarena', 'b500'] | getProductName">
    <ng-container *ngSwitchCase="'wettarena'">
      <current-slip-core></current-slip-core>
    </ng-container>
    <ng-container *ngSwitchCase="'b500'">
      <current-slip-core></current-slip-core>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <ng-container *ngIf="isMobileView">
        <current-slip-core></current-slip-core>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
